import { Badge } from "@/components/ui/badge";
import { formatMoney, pluralize } from "@/lib/format";

// Where a school stands with PagePledge (Schools::AccountOverview):
// on the free trial, paying per campaign, or free.
const ACCOUNT = {
  trial: { label: "Free trial", variant: "warning" },
  paid: { label: "Paid", variant: "success" },
  free: { label: "Free school", variant: "accent" },
};

export default function AccountBadge({ status, className }) {
  const { label, variant } = ACCOUNT[status];
  return <Badge variant={variant} className={className}>{label}</Badge>;
}

// "Spring Read-a-thon 2027 · $900 (Large, their pick)"
export function AwaitingPayment({ awaiting }) {
  return (
    <span>
      <span className="text-foreground">{awaiting.name}</span>
      <span className="text-muted-foreground">
        {" · "}{formatMoney(awaiting.price_cents)} ({awaiting.plan_name}{awaiting.chosen_by_school ? ", their pick" : `, ${pluralize(awaiting.student_count, "student")}`})
      </span>
    </span>
  );
}
